import React, {FC, useCallback} from 'react';
import {Route, RouteProps} from 'react-router-dom';
import {useRouterContext} from './context';

export const NotFoundRoute: FC<
  React.PropsWithChildren<Omit<RouteProps, 'render' | 'component'>>
> = ({children, ...props}) => {
  return (
    <Route {...props}>
      {useCallback(
        (props: any) => {
          if (props.staticContext) {
            props.staticContext.statusCode = 404;
          }
          return children;
        },
        [children],
      )}
    </Route>
  );
};

/**
 * When rendered somewhere on the page, the server will send a status code 404
 */
export const NotFoundStatusCode: FC<React.PropsWithChildren> = ({children}) => {
  const staticContext = useRouterContext();
  if (staticContext) {
    staticContext.statusCode = 404;
  }
  return <>{children}</>;
};
